// ======================================================================
// File Name       : BoxList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Col, Table, Button } from 'react-bootstrap';
import ReduxFormPaging from '../../ReduxFormPaging';

class BoxList extends Component {

  render() {
    const {
      targetBox,
      checkedBoxList,
      targetBoxList,
      checkedBoxOnModal,
      addedBoxList,
    } = this.props;
    const { boxList, recordNum } = targetBox;


    return (
      <Col sm={12} className="padding-clear">
        <Col sm={2} className="margin-top-15">
          <Button onClick={this.props.handleCheckAll}>全選択/解除</Button>
        </Col>
        <Col sm={10} className="text-right">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={this.props.getStartEndData}
          />
        </Col>
        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th className="col-md-1" />
              <th>セクション名</th>
            </tr>
          </thead>
          <tbody>
            { targetBox.allSecernIds.map((boxSecernId, index) => {
              const box = targetBox.bySecernId[boxSecernId];
              const checked = checkedBoxOnModal.indexOf(boxSecernId) > -1;

              return (
                <tr key={index}>
                  <td>
                    <Form.Check
                      type='checkbox'
                      className="text-center margin-clear"
                      value={boxSecernId}
                      checked={!!addedBoxList[boxSecernId] || checked}
                      disabled={!!addedBoxList[boxSecernId]}
                      onChange={this.props.handleCheckbox} />
                  </td>
                  <td>{box.boxName}</td>
                </tr>
              );
            })}

          </tbody>
        </Table>
        <Col sm={12} className="text-center">
          <Button variant="primary" className="btn-96" onClick={this.props.handleAddBox}>
            追加
          </Button>
        </Col>
      </Col>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const { targetBoxList, addedBoxList } = state.csvDownload;
  return { targetBoxList, addedBoxList };
};
export default connect(mapStateToProps)(BoxList);
